import { z } from 'my-zod'
import { attachmentModel } from '../attachment/attachment-model'
import { actionPlanModel } from './action-plans-model'

export const actionPlanSystemView = actionPlanModel.augment({
  overdue: z.boolean().setLabel('Overdue'),
  openedTasks: z.number().setLabel('Open Tasks'),
  closedTasks: z.number().setLabel('Closed Tasks'),
  completion: z.number().setLabel('Percent Complete'),
  attachments: attachmentModel.array()
})
export type actionPlanSystemView = z.infer<typeof actionPlanSystemView>
